import { Lov } from "../../stores/LovStore/LovStore";
import BaseService from "../BaseService";

class LovService extends BaseService {
  getLovById(id: string) {
    return this.fetch<Lov>(`lov/${id}`);
  }

  getLovByCodeAndGroup(code: string, group: string) {
    return this.fetch<Lov>(`lovCode/${code}/${group}`)
      .then((lov: Lov | Lov[] | undefined) => {
        const lovItem = Array.isArray(lov) ? lov[0] : lov || null;
        if (lovItem) {
          lovItem.id = (lovItem as any)._id;
        }
        return lovItem;
      })
      .catch(() => null);
  }

  getLovsByGroup(group: string) {
    return this.fetch<Lov[]>(`lovGroup/${group}`).catch(() => []);
  }

  getLovsByName(name: string) {
    return this.fetch<Lov[]>(`lovName/${name}`).catch(() => []);
  }

  updateLov(id: string, lov: Lov) {
    return this.put<Lov, Lov>(`lov/${id}`, lov);
  }
}

export default LovService;
